export default {
    colors: {
        primary: '#21791D',
        secondary: '#353535',
        tertiary: '#6E2B92'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.primary,
        navItemTransform: 'uppercase',
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/lesnumeriques.js